// Mobile menu toggle
document.addEventListener('DOMContentLoaded', function() {
  const toggle = document.querySelector('.header__mobile-toggle');
  const nav = document.querySelector('.header__nav');

  if (toggle && nav) {
    toggle.addEventListener('click', function() {
      const isOpen = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', !isOpen);
      nav.classList.toggle('is-open');
    });

    // Close menu when clicking outside
    document.addEventListener('click', function(event) {
      if (!event.target.closest('.header__nav') && !event.target.closest('.header__mobile-toggle')) {
        toggle.setAttribute('aria-expanded', 'false');
        nav.classList.remove('is-open');
      }
    });

    // Close menu on escape key
    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape') {
        toggle.setAttribute('aria-expanded', 'false');
        nav.classList.remove('is-open');
      }
    });
  }

  // AJAX Add to Cart
  initAjaxCart();

  // Cart quantity controls
  initCartQuantityControls();
});

// Toast notification system
function showToast(message, type = 'success') {
  // Remove existing toast if any
  const existingToast = document.querySelector('.toast-notification');
  if (existingToast) {
    existingToast.remove();
  }

  const toast = document.createElement('div');
  toast.className = `toast-notification toast-notification--${type}`;
  toast.innerHTML = `
    <svg class="toast-notification__icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      ${type === 'success'
        ? '<path d="M16.6667 5L7.50001 14.1667L3.33334 10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'
        : '<path d="M10 6V10M10 14H10.01M19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'
      }
    </svg>
    <span class="toast-notification__message">${message}</span>
  `;

  document.body.appendChild(toast);

  // Trigger animation
  requestAnimationFrame(() => {
    toast.classList.add('toast-notification--visible');
  });

  // Auto-dismiss after 3 seconds
  setTimeout(() => {
    toast.classList.remove('toast-notification--visible');
    setTimeout(() => toast.remove(), 300);
  }, 3000);
}

// Update cart count in header
function updateCartCount(count) {
  const cartLink = document.querySelector('.header__cart');
  if (!cartLink) return;

  let countBadge = cartLink.querySelector('.header__cart-count');
  const srText = cartLink.querySelector('.visually-hidden');

  if (count > 0) {
    if (!countBadge) {
      countBadge = document.createElement('span');
      countBadge.className = 'header__cart-count';
      countBadge.setAttribute('aria-hidden', 'true');
      cartLink.insertBefore(countBadge, srText);
    }
    countBadge.textContent = count;
  } else if (countBadge) {
    countBadge.remove();
  }

  if (srText) {
    srText.textContent = `Shopping Cart - ${count} items`;
  }
}

// Initialize AJAX cart functionality
function initAjaxCart() {
  const productForm = document.getElementById('product-form');
  if (!productForm) return;

  productForm.addEventListener('submit', async function(event) {
    event.preventDefault();

    const submitButton = productForm.querySelector('.product__add-to-cart');
    const originalText = submitButton.textContent;

    // Show loading state
    submitButton.disabled = true;
    submitButton.innerHTML = `
      <svg class="spinner" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="10" cy="10" r="8" stroke="currentColor" stroke-width="2" stroke-opacity="0.3"/>
        <path d="M10 2C14.4183 2 18 5.58172 18 10" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
      Adding...
    `;

    const formData = new FormData(productForm);

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });

      if (!response.ok) {
        throw new Error('Failed to add to cart');
      }

      // Get updated cart count
      const cartResponse = await fetch('/cart.js');
      const cartData = await cartResponse.json();

      // Update header cart count
      updateCartCount(cartData.item_count);

      // Show success toast
      showToast('Added to cart');

    } catch (error) {
      console.error('Error adding to cart:', error);
      showToast('Failed to add to cart', 'error');
    } finally {
      // Restore button state
      submitButton.disabled = false;
      submitButton.innerHTML = `
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 1H3.5L5.5 13H16M5.5 13L6 15H16M5.5 13L4 4H18L16 13M16 13H6M7 18C7 18.5523 6.55228 19 6 19C5.44772 19 5 18.5523 5 18C5 17.4477 5.44772 17 6 17C6.55228 17 7 17.4477 7 18ZM16 18C16 18.5523 15.5523 19 15 19C14.4477 19 14 18.5523 14 18C14 17.4477 14.4477 17 15 17C15.5523 17 16 17.4477 16 18Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        ${originalText}
      `;
    }
  });
}

// Format cents to dollar string
function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2);
}

// Initialize cart quantity controls with AJAX updates
function initCartQuantityControls() {
  var cartTable = document.querySelector('.cart__table');
  if (!cartTable) return;

  var isUpdating = false;
  var debounceTimer = null;

  function updateCart(itemKey, quantity) {
    if (isUpdating) return;
    isUpdating = true;

    var controls = cartTable.querySelector('.cart__quantity-controls[data-item-key="' + itemKey + '"]');
    if (controls) controls.setAttribute('aria-busy', 'true');

    var updates = {};
    updates[itemKey] = quantity;

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
    .then(function(response) {
      if (!response.ok) throw new Error('Failed to update cart');
      return response.json();
    })
    .then(function(cart) {
      // Update header badge
      updateCartCount(cart.item_count);

      // Update subtotal
      var subtotalEl = document.querySelector('[data-cart-subtotal]');
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price) + ' USD';

      // Update line totals
      cart.items.forEach(function(item) {
        var lineTotalEl = cartTable.querySelector('[data-cart-line-total][data-item-key="' + item.key + '"]');
        if (lineTotalEl) lineTotalEl.textContent = formatMoney(item.final_line_price);

        var inputEl = cartTable.querySelector('.cart__quantity-controls[data-item-key="' + item.key + '"] [data-quantity-input]');
        if (inputEl) inputEl.value = item.quantity;
      });

      // Handle removed item (quantity set to 0)
      if (quantity === 0) {
        var row = cartTable.querySelector('tr[data-cart-item-key="' + itemKey + '"]');
        if (row) {
          row.style.opacity = '0';
          setTimeout(function() {
            row.remove();
            if (cart.item_count === 0) {
              window.location.reload();
            }
          }, 300);
        }
        showToast('Item removed from cart');
      } else {
        showToast('Cart updated');
      }
    })
    .catch(function() {
      showToast('Failed to update cart', 'error');
    })
    .finally(function() {
      isUpdating = false;
      if (controls) controls.removeAttribute('aria-busy');
    });
  }

  // Event delegation for +/- buttons
  cartTable.addEventListener('click', function(event) {
    var btn = event.target.closest('.cart__quantity-btn');
    if (btn) {
      var controls = btn.closest('.cart__quantity-controls');
      var itemKey = controls.getAttribute('data-item-key');
      var input = controls.querySelector('[data-quantity-input]');
      var currentQty = parseInt(input.value, 10) || 0;
      var action = btn.getAttribute('data-action');

      if (action === 'increase') {
        input.value = currentQty + 1;
        updateCart(itemKey, currentQty + 1);
      } else if (action === 'decrease') {
        var newQty = Math.max(0, currentQty - 1);
        input.value = newQty;
        updateCart(itemKey, newQty);
      }
      return;
    }

    // Handle remove link
    var removeLink = event.target.closest('[data-cart-remove]');
    if (removeLink) {
      event.preventDefault();
      var itemKey = removeLink.getAttribute('data-item-key');
      updateCart(itemKey, 0);
    }
  });

  // Debounced input handler for direct typing
  cartTable.addEventListener('input', function(event) {
    var input = event.target.closest('[data-quantity-input]');
    if (!input) return;

    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function() {
      var controls = input.closest('.cart__quantity-controls');
      var itemKey = controls.getAttribute('data-item-key');
      var newQty = parseInt(input.value, 10);
      if (isNaN(newQty) || newQty < 0) newQty = 0;
      updateCart(itemKey, newQty);
    }, 500);
  });
}
